import type { Dashboard, DashboardFilters } from "@/types";

import { api } from "@/services/api";

export class DashboardRepository {
  async get(filters: DashboardFilters): Promise<Dashboard> {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.set(key, String(value));
    });

    const response = await api.get(`/v1/admin/dashboard?${params.toString()}`);

    return response.data;
  }
}
